<template>
  <div v-if="canCreateAgent">
    <b-card class="mb-4">
      <TitleTable titleTable="Create Agent" iconTable="fas fa-user-plus" />
      
      <div class="m-1">
        <b-row>
          <b-col cols="12" class="d-flex justify-content-end">
            <GoBack class="mr-2" />
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-card>
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-form
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm">
          <b-row>
            <b-col cols="12" md="6">
              <validation-provider
                #default="validationContext"
                name="Name"
                rules="required">
                <b-form-group label="Name" label-for="name">
                  <b-form-input
                    id="name"
                    v-model="formData.name"
                    :state="getValidationState(validationContext)"
                    trim
                    placeholder="John" />

                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" md="6">
              <validation-provider
                #default="validationContext"
                name="Lastname"
                rules="required">
                <b-form-group label="Lastname" label-for="lastname">
                  <b-form-input
                    id="lastname"
                    v-model="formData.lastname"
                    :state="getValidationState(validationContext)"
                    trim
                    placeholder="Doe" />

                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <!-- <b-row class="mt-3">
            <b-col cols="12" md="6">
              <validation-provider
                #default="validationContext"
                name="Admin"
                rules="required">
                <b-form-group label="Assign to Admin" label-for="admin-select">
                  <b-form-select
                    id="admin-select"
                    v-model="selectedAdmin"
                    :options="adminSelectOptions"
                    :disabled="saving"
                    :state="getValidationState(validationContext)"
                    required
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row> -->

          <div class="d-flex mt-3">
            <b-button
              variant="primary"
              class="mr-2"
              type="submit"
              :disabled="saving">
              <span v-if="!saving">Create Agent</span>
              <span v-else>
                <b-spinner small class="mr-1"></b-spinner>
                Creating...
              </span>
            </b-button>
            <b-button type="reset" variant="outline-secondary" :disabled="saving">
              Clear
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </b-card>
    
    <ToastNotification ref="toast" />
  </div>
  <div v-else>
    <b-alert variant="danger" show>
      <h4 class="alert-heading">Access Denied</h4>
      <div class="alert-body">
        You don't have permission to access this page.
      </div>
    </b-alert>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  // BFormSelect,
  BButton,
  BSpinner,
  BAlert,
} from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations';
import TitleTable from '@/components/TitleTable.vue';
import GoBack from '@/components/ButtonBack.vue';
import ToastNotification from '@/components/ToastNotification.vue';
import axiosU from '@/core/services/api/admin/user';
import axiosF from '@/core/services/api/admin/facilities';
import { createAdminAgentUser } from '@/core/services/api/admin/adminAgentUser';
import { normalizeDateToMDY } from '@/core/utils/utils';

export default {
  name: 'CreateAgentPage',
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    // BFormSelect,
    BButton,
    BSpinner,
    BAlert,
    TitleTable,
    GoBack,
    ToastNotification,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    const blankFormData = {
      name: '',
      lastname: '',
    };
    return {
      required,
      formData: JSON.parse(JSON.stringify(blankFormData)),
      saving: false,
      facilityOptions: [],
      // adminCatalog: [],
      // selectedAdmin: null,
    };
  },
  computed: {
    canCreateAgent() {
      // Solo Frontdesk (rol 5) y SuperAdmin (rol 1) pueden crear agentes
      const storedUser = localStorage.getItem('userData');
      if (!storedUser) return false;
      try {
        const parsed = JSON.parse(storedUser);
        const roles = parsed?.roles || [];
        return Array.isArray(roles) && roles.some(role => {
          const roleId = Number(role.id);
          return roleId === 5 || roleId === 1; // Frontdesk o SuperAdmin
        });
      } catch (error) {
        return false;
      }
    },
    // adminSelectOptions() {
    //   const composeName = (user = {}) => {
    //     const parts = [user.name, user.lastname].filter(Boolean);
    //     return parts.length ? parts.join(' ') : user.email || `User ${user.id}`;
    //   };
    //   return [
    //     { value: null, text: 'Select admin' },
    //     ...this.adminCatalog.map((admin) => ({
    //       value: admin.id,
    //       text: composeName(admin),
    //     })),
    //   ];
    // },
  },
  mounted() {
    // Verificar permisos antes de abrir
    if (!this.canCreateAgent) {
      this.$router.push({ name: '404' });
      return;
    }
    this.fetchFacilities();
    // this.fetchAdminCatalog();
  },
  methods: {
    async fetchFacilities() {
      try {
        const { data } = await axiosF.facilityList(1000);
        const facilityList = data.map((item) => ({
          facilities_id: item.id,
          ...item,
        }));
        this.facilityOptions = facilityList;
      } catch (error) {
        console.error('Error fetching facilities:', error);
        this.facilityOptions = [];
      }
    },
    // async fetchAdminCatalog() {
    //   try {
    //     const response = await listAdminsCatalog();
    //     const data = Array.isArray(response?.data) ? response.data : response;
    //     this.adminCatalog = Array.isArray(data) ? data : [];
    //   } catch (error) {
    //     console.error('Error fetching admin catalog:', error);
    //     this.adminCatalog = [];
    //   }
    // },
    async onSubmit() {
      this.saving = true;
      
      try {
        // Obtener todos los IDs de facilities
        const allFacilityIds = this.facilityOptions
          .map((option) => option.id ?? option.facilities_id)
          .filter((id) => id !== undefined && id !== null);

        // Contraseña por defecto: 123456789
        const password = '123456789';

        // Formatear fecha de nacimiento (usar fecha actual como valor por defecto)
        const dateBirth = normalizeDateToMDY(new Date());

        // Crear usuario con rol 7 (Agent) y todas las facilities
        const payload = {
          name: this.formData.name,
          lastname: this.formData.lastname,
          email: `${this.formData.name.toLowerCase()}.${this.formData.lastname.toLowerCase()}@agent.com`, // Email temporal
          password: password,
          passwordRepeat: password,
          roles: [7], // Rol de Agent
          facilities: allFacilityIds, // Todas las facilities
          cities_id: 1211, // Valor por defecto (mismo que UserAdd.vue)
          zip_code: '00000', // Valor por defecto para evitar error de null
          date_birth: dateBirth, // Fecha de nacimiento formateada
          pay_to_visit: 10, // pago por visita
        };

        // Limpiar espacios de campos que puedan tenerlos (como IMEI si existe)
        if (payload.imei) {
          payload.imei = payload.imei.replace(/\s+/g, '');
        }

        // PRIMERA SOLICITUD: Crear el usuario
        const response = await axiosU.userCreate(payload);
        
        // Verificar si hay un error en la respuesta
        if (response?.status === 'ERROR' || response?.data?.status === 'ERROR') {
          const errorMessage = response?.message || response?.data?.message || 'Error creating agent';
          throw new Error(errorMessage);
        }
        
        // Obtener el ID del usuario creado de la respuesta
        // La respuesta tiene la estructura: { status: "OK", registro: { id: ... } }
        const newAgentId = response?.registro?.id || 
                          response?.data?.registro?.id || 
                          response?.data?.id || 
                          response?.id ||
                          response?.data?.user?.id ||
                          response?.user?.id;

        if (!newAgentId) {
          console.error('User created but ID not found in response. Full response:', response);
          throw new Error('User created but ID not returned. Please check the console for details.');
        }

        // SEGUNDA SOLICITUD: Asignar al admin con ID 49058 usando el ID de la respuesta anterior
        try {
          await createAdminAgentUser({
            admin_user_id: 49058,
            agent_user_id: newAgentId,
          });
          this.$refs.toast.success('Agent created and assigned to admin successfully!');
        } catch (assignError) {
          console.error('Error assigning admin:', assignError);
          // El usuario se creó pero falló la asignación
          this.$refs.toast.warning('Agent created successfully, but failed to assign to admin. You can assign it later.');
        }

        // Limpiar formulario
        this.resetForm();
      } catch (error) {
        console.error('Error creating agent:', error);
        const errorMessage =
          error?.response?.data?.message ||
          error?.message ||
          'Error creating agent. Please try again.';
        this.$refs.toast.danger(errorMessage);
      } finally {
        this.saving = false;
      }
    },
    resetForm() {
      this.formData = {
        name: '',
        lastname: '',
      };
      // this.selectedAdmin = null;
      if (this.$refs.refFormObserver) {
        this.$refs.refFormObserver.reset();
      }
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
};
</script>

<style scoped>
</style>

